import { ServiceTypes } from 'constants/ServiceTypes';
import { DataKey } from 'enums/DataKey';
import { TabsNames } from 'enums/TabsNames';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useInjection } from 'services/ioc/ioc.react';
import { ColumnsStore } from 'stores/ColumnsStore';
import { UiStore } from 'stores/UiStore';
import { ColumnList, ConfiguratorWrapper, StyledCheckbox, StyledCloseIcon, Title } from './styles/ColumnConfiguratorStyles';

const ColumnsConfigurator: React.FC = observer(() => {
  const columnsStore = useInjection<ColumnsStore>(ServiceTypes.ColumnsStore);
  const uiStore = useInjection<UiStore>(ServiceTypes.UiStore);

  const columnVisibilityHandler = (event: React.ChangeEvent<HTMLInputElement>, checked: boolean): void => {
    columnsStore.changeColumnVisibility(event.target.name, checked);
  };

  const closeHandler = () => {
    columnsStore.changeConfiguratorVisibility(false);
  };

  const changeAllColumnsHandler = (event: React.ChangeEvent<HTMLInputElement>, checked: boolean): void => {
    columnsStore.changeAllColumns(checked);
  };

  const getColumns = () => {
    if (uiStore.activeTab === TabsNames.BallTracking) {
      return columnsStore.columns.filter((column) => column.type?.includes(TabsNames.BallTracking));
    }
    if (uiStore.activeTab === TabsNames.PlayerTracking) {
      return columnsStore.columns.filter((column) => column.type?.includes(TabsNames.PlayerTracking));
    }
    return columnsStore.columns;
  };

  return (
    <ConfiguratorWrapper>
      <Title>
        Visible columns
        <StyledCloseIcon onClick={closeHandler} />
      </Title>
      <ColumnList>
        <StyledCheckbox checked={!columnsStore.countHiddenColumns()} label='All' reversed name='all' onChange={changeAllColumnsHandler} />

        {getColumns().map((columnItem) => {
          if (columnItem.dataKey !== DataKey.TrackStartTimeLocal) {
            return (
              <StyledCheckbox
                checked={columnItem.isChecked}
                label={columnItem.columnName}
                reversed
                name={columnItem.columnName}
                onChange={columnVisibilityHandler}
              />
            );
          }
        })}
      </ColumnList>
    </ConfiguratorWrapper>
  );
});

export default ColumnsConfigurator;
